import type { FC } from 'react';
import { memo, useMemo } from 'react';
import type { Route } from '../../bootstrap/router/hooks';
import { Text, TextLink, Title } from '../../bootstrap/typography';
import { Divider } from '../../bootstrap/components';
import s from './index.module.scss';

export const AboutPage: FC = memo(() => {
  return (
    <div className={s.page}>
      <Title size={1} color={1} className={s.title}>
        Grigorii Zheliabin
      </Title>
      <Text size="1" color="3" className={s.text}>
        Hello there! I am Grigorii Zheliabin, a man who loves programming very much.
      </Text>
      <Text size="1" color="3" className={s.text}>
        I am a software developer currently based in Tbilisi, Georgia. Dreaming up ideas that
        inspires me and others and making them come true is where my passion lies. You can see the
        full list of my projects{' '}
        <TextLink size="1" color="1" className={s.link} to="/projects" isUnderline>
          here
        </TextLink>
        . I am also eager to speak at conferences and share my knowledge with people.
      </Text>
      <Text size="1" color="3" className={s.text}>
        Outside of programming, I enjoy writing books, playing video games, and traveling. I am very
        disposed to meet good people, so if we find ourselves in the same city, we can meet and
        chat.
      </Text>
      <Divider className={s.divider} />
      <Text size="1" color="3" className={s.text}>
        Find me on{' '}
        <TextLink size="1" color="1" className={s.link} href="https://github.com/gzhel">
          GitHub
        </TextLink>{' '}
        or{' '}
        <TextLink size="1" color="1" className={s.link} href="https://www.linkedin.com/in/gzhel/">
          LinkedIn
        </TextLink>
        . <br />
        Mail me at{' '}
        <TextLink size="1" color="1" className={s.link} href="mailto:gregoryzhel@gmail.com">
          gregoryzhel@gmail.com
        </TextLink>
        . <br />
      </Text>
    </div>
  );
});

export const useAboutRoute = () => {
  const route = useMemo<Route>(
    () => ({
      path: '/',
      element: AboutPage
    }),
    []
  );

  return { route };
};
